/**
 * Custom Element für purchase DataLayer Events
 *
 * Reiner Datencontainer für purchase-bezogene Attribute.
 * Die Logik zum Sammeln und Pushen übernimmt der PurchaseHandler.
 * Unterstützt dl-product Child-Elemente für das items Array.
 *
 * Verwendung:
 * <dl-purchase transaction-id="T12345" value="99.99">
 *   <dl-product item-id="SKU123" item-name="Product 1" price="49.99"></dl-product>
 *   <dl-product item-id="SKU456" item-name="Product 2" price="49.99"></dl-product>
 * </dl-purchase>
 */
export default class DlPurchase extends HTMLElement {
    static get tag() {
        return "dl-purchase";
    }

    static {
        if (!customElements.get(DlPurchase.tag)) {
            customElements.define(DlPurchase.tag, DlPurchase);
        }
    }

    /**
     * Gibt alle dl-product Child-Elemente zurück
     * @returns {NodeList} Liste aller dl-product Child-Elemente
     */
    get itemElements() {
        return this.querySelectorAll("dl-product") || [];
    }

    /**
     * Sammelt alle Attribute dieses Elements als Key-Value-Objekt
     * @returns {Object} Objekt mit allen Attributen als key-value Paare
     */
    get params() {
        return this._getAttributesAsObject(this);
    }

    /**
     * Sammelt alle Items (dl-product Elemente) als Array
     * @returns {Array<Object>} Array mit allen Item-Daten
     */
    get items() {
        const items = [];

        this.itemElements.forEach(element => {
            const itemData = this._getAttributesAsObject(element);
            if (Object.keys(itemData).length > 0) {
                items.push(itemData);
            }
        });

        return items;
    }

    /**
     * Extrahiert alle Attribute eines Elements als Key-Value-Objekt
     * @param {HTMLElement} element - Das Element, dessen Attribute extrahiert werden sollen
     * @returns {Object} Objekt mit allen Attributen als key-value Paare
     * @private
     */
    _getAttributesAsObject(element) {
        const attributes = {};

        if (!element || !element.attributes) {
            return attributes;
        }

        // Iteriere über alle Attribute des Elements
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes[i];
            attributes[attr.name] = attr.value;
        }

        return attributes;
    }
}
